import React, { FC, useEffect } from 'react'
import { Svg_s } from "styles/app-styles"
import { ExcelImportIcon } from "images/icons/tools"
import keyService, * as chord from "data/key"
import importService from "data/import"

const ImportIcon: FC<{info?: any}> = (props) => {

  useEffect(() => {
    keyService.stream().subscribe(k => {
      if (k.chord === chord.ESC) importService.showImport(false);
    })
  }, [])

  return (
  <div><Svg_s onClick={()=>importService.showImport(true, props.info)} src={ExcelImportIcon} style={{height: '28px', display: 'flex'}} /></div>
  )
}

export default ImportIcon